import {useHistory} from 'react-router-dom';
import "../home/home.css";
import 'firebase/firestore';
import Header from '../home/header/header';
import './upload-survey.css'
import textlogo from "../../static/textlogo.png";
import Sider from "./form-menu";
import React from "react";
import TermOfUsePopup from "../term-of-use-popup/term-of-use"
import {Auth, db} from "../../index";

const UploadSurvey = () => {
    const history = useHistory()
    const [signedIn, setSignedIn] = React.useState(sessionStorage.getItem("signedIn"));
    const [surveyName, setSurveyName] = React.useState(0);
    const [surveyAssociation, setSurveyAssociation] = React.useState(0);
    const [surveyPlatform, setSurveyPlatform] = React.useState("");
    const [surveyLanguage, setSurveyLanguage] = React.useState("English");
    const [surveyTarget, setSurveyTarget] = React.useState("UW students");
    const [surveyDetails, setSurveyDetails] = React.useState(0);
    const [surveyMoreDetails, setSurveyMoreDetails] = React.useState(0);
    const [surveyLink, setSurveyLink] = React.useState(0);
    const [surveyDeadlineDate, setSurveyDeadlineDate] = React.useState(0);
    const [surveyDeadlineTime, setSurveyDeadlineTime] = React.useState(0);

    const handleLogOut = () => {
        Auth.signOut();
        setSignedIn(false)
        history.push("/home")
    }

    const handleChangeName = (event) => {
        setSurveyName(event.target.value);
    };

    const handleChangeAssociation = (event) => {
        setSurveyAssociation(event.target.value);
    };

    const handleSurveyPlatform = (event) => {
        setSurveyPlatform(event.target.value);
    };

    const handleChangeLanguage = (event) => {
        setSurveyLanguage(event.target.value);
    };
    const handleChangeTarget = (event) => {
        setSurveyTarget(event.target.value);
    };

    const handleChangeDetails = (event) => {
        setSurveyDetails(event.target.value);
    };

    const handleChangeMoreDetails = (event) => {
        setSurveyMoreDetails(event.target.value);
    };

    const handleChangeLink = (event) => {
        setSurveyLink(event.target.value);
    };

    const handleChangeDeadlineDate = (event) => {
        setSurveyDeadlineDate(event.target.value);
    };

    const handleChangeDeadlineTime = (event) => {
        setSurveyDeadlineTime(event.target.value);
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        console.log(surveyName);
        db.collection('submittedSurvey').add({
            censored: false,
            survey_name: surveyName,
            description: surveyDetails,
            survey_platform: surveyPlatform,
            survey_link: surveyLink,
            survey_association: surveyAssociation,
            survey_language: surveyLanguage,
            target_group: surveyTarget,
            deadline: surveyDeadlineDate,
            deadlineTime: surveyDeadlineTime,
            survey_more_details: surveyMoreDetails,
            timestamp: Date.now(),
            uid: Auth.currentUser.uid
        });
        history.push("/upload-successful");
    }

    return (
        <>
            <div className="header-box">
                <Header signedIn={signedIn} handleLogOut={handleLogOut} param={"UPLOAD"}/>
            </div>
            <div className="upload-container">
                <div id="upload-left-container">
                    <img id="ontheupload" src={textlogo} alt="HuaPsych"/>
                    <Sider/>
                </div>
                <form className="upload-right-container" onSubmit={handleSubmit}>
                    <section id="basics">
                        <h1>Survey basics</h1>
                        <div>
                            <p>What is your survey's name?</p>
                            <input onChange={handleChangeName} placeholder="" required>
                            </input>
                        </div>
                        <div>
                            <p>What is your survey association? (research lab, course project, other organizations, etc).</p>
                            <input onChange={handleChangeAssociation} placeholder="" required>
                            </input>
                        </div>
                        <div>
                            <p>What is your survey platform?</p>
                            <select name="language" id="language" onChange={handleSurveyPlatform}>
                                <option value="Google Form">Google Form</option>
                                <option value="Survey Monkey">Survey Monkey</option>
                                <option value="腾讯问卷">腾讯问卷</option>
                                <option value="问卷星">问卷星</option>
                                <option value="Others">Others</option>
                            </select>
                        </div>
                        <div>
                            <p>Which language is your survey based on?</p>
                            <select name="language" id="language" onChange={handleChangeLanguage}>
                                <option value="English">English</option>
                                <option value="Chinese">Chinese</option>
                            </select>
                        </div>
                        <div>
                            <p>Who does your survey target?</p>
                            <input onChange={handleChangeTarget} placeholder="e.g. UW students" required>
                            </input>
                        </div>
                    </section>
                    <section id="details">
                        <h1>Details</h1>
                        <div>
                            <p>Please describe your survey.</p>
                            <input onChange={handleChangeDetails} placeholder="Enter key information that you want participants to know. E.g. describe what you are researching.">
                            </input>
                        </div>
                        <div>
                            <p>Please add more details of your survey if needed.</p>
                            <input onChange={handleChangeMoreDetails} placeholder="Add any other details that you wish to share with participants. ">
                            </input>
                        </div>
                    </section>
                    <section id="link">
                        <h1>Link</h1>
                        <div>
                            <p>Please type in the link for participants to fill out your survey.</p>
                            <input onChange={handleChangeLink} placeholder="" required>
                            </input>
                        </div>
                    </section>
                    <section id="deadline">
                        <h1>Deadline</h1>
                        <div>
                            <p>What is the deadline of your survey?</p>
                            <input type="date" id="start" name="trip-start"
                                   min="2021-01-01" max="2050-12-31" required onChange={handleChangeDeadlineDate}/>
                            <input type="time" id="ampm" name="ampm" required onChange={handleChangeDeadlineTime}/>
                        </div>
                    </section>
                    <section id="termsofagreement">
                        <h1>Terms of agreement</h1>
                        <div>
                            <input type="checkbox" id="terms" name="terms" required/>
                            <label htmlFor="terms">
                                I agree the
                                <TermOfUsePopup triggerElement={() =>{
                                    return (<span id='term-clickible-text'> term of use </span>)
                                 }}/>
                                and understand that the content I provided above does not contain hate speech,
                                harassment and criticism, misinformation, private information, etc.
                            </label>
                        </div>
                    </section>
                    <input type="submit" value="Submit"/>
                </form>
            </div>
        </>
    );
}

export default UploadSurvey;